import {whiteColor, blackColor, blueColor, DodgerBlueColor} from '../cmsMainStyle'

const drawerWidth = 300
const navBarStyle = theme => ({
    root: {
        display: 'flex'
    },

    appBar: {
        background: whiteColor,
        color: blackColor,
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
        })
    },

    // appBarShift: {
    //     marginLeft: drawerWidth,
    //     width: '100%',
    //     transition: theme.transitions.create(['width', 'margin'], {
    //       easing: theme.transitions.easing.sharp,
    //       duration: theme.transitions.duration.enteringScreen
    //     })
    // },

    menuIcon: {
        color: blueColor[12],
    },

    logo: {
        flexGrow: 1,
    },
  
    menuButton: {
        marginLeft: 10,
        marginRight: 10
    },
    
    hide: {
        display: 'none'
    },
    
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',

        // paper: {
        //     background: 'blue'
        //   }
    },
    
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },

    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),

        overflowX: 'hidden',
        // width: theme.spacing(7),

        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(8)
        },

        [theme.breakpoints.down('sm')]: {
            width: theme.spacing(0)
        }
    },
    
    sideMenuSpace: {
        margin: theme.spacing(5)
    },
    
    content: {
        flexGrow: 1,
        paddingTop: theme.spacing(8),
        

        // paddingTop: theme.spacing(10),
        // paddingLeft: theme.spacing(2),
        // paddingRight: theme.spacing(2)
    },
    
    nested: {
        paddingLeft: theme.spacing(4),
    },
    
    paper: {
        // background: 'rgba(0, 122, 204, 1)'
        background: DodgerBlueColor[11]
    },

    dividerColor: {
        backgroundColor: '#2952a3'
    },

    menuIconProperties: {
        color: whiteColor
    },

    menuTextProperties: {
        color: whiteColor,
        fontWeight: 'Bold'
    },

    activeLinkProperties: {
        color: 'Transparent',
    },

    paper1: {
        textAlign: "center",
    },

})


export default navBarStyle  